function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.503 4.906a12.001 12.001 0 11-4.15 15.632 1 1 0 10-1.774.924 14.001 14.001 0 0021.587 4.118l5.127 5.127a1 1 0 001.414-1.414l-5.127-5.127A14.002 14.002 0 102.675 10.692a1 1 0 101.904.615 12.001 12.001 0 014.924-6.401z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.928 9.629a1 1 0 00-1.822-.076L9.382 15H1a1 1 0 100 2h9a1 1 0 00.894-.553L12.9 12.44l3.173 7.932a1 1 0 001.796.125l3.198-5.595 1.102 1.654a1 1 0 001.664-1.11l-2-3a1 1 0 00-1.7.059l-2.973 5.202-3.23-8.077z",
  fill: "currentColor"
})));